import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLockedMapPin, useSetMapPin } from 'features/mapping/mapPin';
import { MapToolsMenuItemProps } from './types';

export const DropPinMenuItem = (props: MapToolsMenuItemProps): JSX.Element => {
  const { position, onClick, padding } = props;
  const { t } = useTranslation();
  const { setSelectedMapPin } = useSetMapPin();
  const { isLocked, goToLockedPin } = useLockedMapPin();

  const handleClick = (): void => {
    if (isLocked) {
      // Locked: go to the pin instead of dropping a new one.
      goToLockedPin();
    } else {
      setSelectedMapPin({ lat: position.lat, lng: position.lng });
    }
    onClick();
  };

  return (
    <MenuItem onClick={handleClick} sx={{ padding }}>
      {isLocked
        ? t('map.contextMenu.goToLockedPinBtnTitle')
        : t('map.contextMenu.dropPinBtnTitle')}
    </MenuItem>
  );
};
